import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../../styles/pages/home/HomeWorkProject.css";

export default class HomeWork extends Component {
  render() {
    var className = this.props.name.replace(/'/g, "");
    return (
      <Link
        to={`/${this.props.link}`}
        className={`HomeWorkProject ${className} on-scroll-anim`}
      >
        {/* The Project Image */}
        <div
          className="image-container"
          style={{ background: this.props.color }}
        >
          <img alt={this.props.subText} src={this.props.image} />

          {/* The Overlay (For Mouse Interaction) */}
          <div className="overlay-container">
            <div className="g-sub-title white">{this.props.name}</div>
            <div className="g-sub-text white">{this.props.subText}</div>
            <div className="g-button white">View Project</div>
          </div>
        </div>

        {/* The Text (For Touch Screens) */}
        <div className="text-container">
          <div className="g-sub-title">{this.props.name}</div>
          <div className="g-sub-text">{this.props.subText}</div>
          <div className="g-button">View Project</div>
        </div>
      </Link>
    );
  }
}
